import { format, setHours, setISODay, setMinutes } from 'date-fns'

import React from 'react'
import locales from '../utils/locales'

const date = new Date()

export default ({ hours, locale }) => {
  return (
    <table>
      <tbody>
        {hours.map(({ node: { id, day, from, to } }) => {
          return (
            <tr key={id}>
              <th>
                {format(setISODay(date, day), 'EEEE', {
                  locale: locales[locale].localeData,
                })}
              </th>
              <td>
                {format(
                  setMinutes(setHours(date, from.hours), from.minutes),
                  'H:mm'
                )}{' '}
                -{' '}
                {format(
                  setMinutes(setHours(date, to.hours), to.minutes),
                  'H:mm'
                )}
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
